import { useEffect } from 'react'
import { WORK_STATUS_EVENT } from '@/features/chat/phase1/proposalWorkStatus'
import { applyLiveWorkStatus } from './applyLiveWorkStatus'

export function useLiveWorkStatus(displayThreadId, setMessagesByThreadId) {
  useEffect(() => {
    if (!displayThreadId || typeof window === 'undefined') return undefined
    const onWorkStatus = (event) => {
      setMessagesByThreadId((prev) => applyLiveWorkStatus(prev, displayThreadId, event.detail))
    }
    window.addEventListener(WORK_STATUS_EVENT, onWorkStatus)
    return () => window.removeEventListener(WORK_STATUS_EVENT, onWorkStatus)
  }, [displayThreadId, setMessagesByThreadId])
}
